import {
  SignInPage,
  type SignInProviderConfig,
} from '@backstage/core-components';
import { gitlabAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

/**
 * Ubiwhere's self-managed GitLab is the production identity provider. The
 * `id` must match the auth provider id served by the backend
 * (`@backstage/plugin-auth-backend-module-gitlab-provider`).
 */
export const gitlabProvider: SignInProviderConfig = {
  id: 'gitlab-auth-provider',
  title: 'GitLab',
  message: 'Sign in with your gitlab.ubiwhere.com account',
  apiRef: gitlabAuthApiRef,
};

/**
 * Overrides the default `sign-in-page:app` extension from
 * `@backstage/plugin-app`, which offers anonymous guest sign-in. GitLab OAuth is
 * the only sign-in path in every environment, local development included, so no
 * other provider is listed here.
 */
export const AppSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          title="Ubiwhere Backstage"
          align="center"
          providers={[gitlabProvider]}
        />
      ),
  },
});
